export default "assets/images/blason-secondary-f3b060b3.png";